import { render, staticRenderFns } from "./TestVideoExplanationText.vue?vue&type=template&id=6158fefa&scoped=true&"
import script from "./TestVideoExplanationText.vue?vue&type=script&lang=js&"
export * from "./TestVideoExplanationText.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoExplanationText.vue?vue&type=style&index=0&id=6158fefa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158fefa",
  null
  
)

export default component.exports